import React, { useEffect, useRef, useState } from "react";
import emailjs from "emailjs-com";

const Asociarme = () => {
  const formRef = useRef();
  const [message, setMessage] = useState({ text: "", color: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    emailjs.init("_eTkTbxWx9YBMGy0B");
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    const formData = new FormData(formRef.current);
    const data = Object.fromEntries(formData.entries());

    emailjs
      .send("service_pql46vo", "template_qgjndmh", {
        nombre: data.nombre,
        apellido: data.apellido,
        telefono: data.telefono,
        mail: data.mail,
        direccion: data.direccion,
      })
      .then(() => {
        formRef.current.reset();
        window.location.href =
          "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=89c629dad23c4d1289822ac23c2c0581";
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error("Error al enviar el formulario:", error);
        setMessage({
          text: "Hubo un error al enviar el formulario. Intenta nuevamente.",
          color: "red",
        });
      });
  };

  return (
    <section className="relative min-h-screen mx-auto px-4 flex flex-col items-center mt-16">
      <div className="container max-w-lg px-6 mx-auto py-12 md:py-24 flex flex-col items-center">
        <h1 className="text-secondary text-center w-auto pb-8 md:pb-12">
          Nuestra suscripción
        </h1>

        {/* Contenedor único en formato de una sola columna */}
        <div className="w-full p-6 bg-white backdrop-blur-sm bg-opacity-50 rounded-xl text-center shadow-md flex flex-col gap-8">
          {/* Bloque de precio e información básica */}
          <div className="border-b border-gray-300 pb-6">
            <p className="text-secondary text-sm">La cuota actual</p>
            <h3 className="text-secondary my-1 text-3xl font-bold">
              $9.075 <span className="text-sm font-normal">/mes</span>
            </h3>
            <small className="text-xs text-gray-500 block mt-2">
              Cobrados semestralmente de tu tarjeta de crédito.
            </small>
          </div>

          {/* Bloque del formulario */}
          <div>
            <h2 className="mb-6 text-xl font-semibold">
              ¡Suscribite ahora mismo!
            </h2>
            <form
              id="contactForm"
              ref={formRef}
              onSubmit={handleSubmit}
              className="flex flex-col gap-4 w-full"
            >
              <input
                type="text"
                name="nombre"
                placeholder="Nombre"
                required
                className="w-full border-b-2 rounded-lg border-gray-300 p-2 text-base focus:outline-none"
              />
              <input
                type="text"
                name="apellido"
                placeholder="Apellido"
                required
                className="w-full border-b-2 rounded-lg border-gray-300 p-2 text-base focus:outline-none"
              />
              <input
                type="tel"
                name="telefono"
                placeholder="Teléfono"
                pattern="[0-9]{6,15}"
                required
                className="w-full border-b-2 rounded-lg border-gray-300 p-2 text-base focus:outline-none"
              />
              <input
                type="email"
                name="mail"
                placeholder="Mail"
                required
                className="w-full border-b-2 rounded-lg border-gray-300 p-2 text-base focus:outline-none"
              />
              <input
                type="text"
                name="direccion"
                placeholder="Dirección"
                required
                className="w-full border-b-2 rounded-lg border-gray-300 p-2 text-base focus:outline-none"
              />
              <button
                disabled={isSubmitting}
                type="submit"
                className={`${
                  isSubmitting
                    ? "bg-gray-200 text-black"
                    : "bg-gradient-to-r from-quaternary to-tertiary text-black hover:text-white hover:to-secondary hover:from-secondary transition"
                } mt-4 w-full px-6 py-2 rounded-lg font-bold`}
              >
                {isSubmitting ? "Redirigiendo..." : "Enviar y pagar"}
              </button>
            </form>
            <div
              id="formMessage"
              className="mt-4 font-bold"
              style={{ color: message.color }}
            >
              {message.text}
            </div>
          </div>
        </div>
      </div>
      <img
        className="absolute w-full h-full object-cover -z-20"
        src="/asociarme.jpg"
        alt="apreton de manos"
      />
    </section>
  );
};

export default Asociarme;
